<template src="./RegisterExames.html"></template>
<script>
import mixins from "../../../../../Mixins.js";
export default {
  mixins: [mixins],
  data() {
    return {
      showContent: false,
      exames: undefined,
      windowWidth: 0,
      currentx: 1,
      numPages: 0,
      pagination: false,
      searchExames: "",
      popupExame: false,
      popupExameData: {
        active: undefined,
        codTuss: undefined,
        codExame: undefined,
        id: undefined,
        name: undefined,
      },
      invalidFields: {
        name: false,
        codExame: false
      },
      dangerMessage: "Campo obrigatório",
      toggleActiveId : null
    }
  },
  mounted() {
    const vm = this;
    vm.init();
  },
  created() {
    const vm = this;
    window.addEventListener("resize", vm.handleResize);
    vm.handleResize();
  },
  destroyed() {
    const vm = this;
    window.removeEventListener("resize", vm.handleResize);
  },
  watch: {
    'popupExameData.name': function(newVal) {
        const vm = this;
        vm.invalidFields.name = vm.testNullUndefinedEmpty(newVal) && vm.invalidFields.name;
    },
    'popupExameData.codExame': function(newVal) {
        const vm = this;
        vm.invalidFields.codExame = vm.testNullUndefinedEmpty(newVal) && vm.invalidFields.codExame;
    },
    currentx: function () {
      const vm = this;
      vm.changePagination();
    },
  },
  methods: {
    init() {
      const vm = this;
      vm.getExames();
    },

    getExames() {
      const vm = this;
      const page =  vm.currentx - 1;
      vm.axios
        .get(
          vm.$store.state.filooServer +
          "exames?page=" + page + "&search=" + vm.searchExames + "&size=10&sort=id,asc", {
            headers: {
              Authorization: vm.$session.get("bearerDefault")
            },
          }
        )
        .then(function (response) {
          if (response.status == 200) {
            vm.exames = response.data.content;
            vm.numPages = response.data.totalPages;
            vm.pagination = vm.numPages > 1;
            vm.showContent = true;
          }
        }).finally(() => {
          vm.$vs.loading.close();
        });
    },

    changePagination() {
      const vm = this;
      vm.getExames();
    },

    confirmeChangeStatus(id) {
      const vm = this;
      vm.toggleActiveId = id;
      vm.$bvModal.show("modal-change-status-exam");
    },
    toggleActive() {
      const vm = this;
      vm.axios
      .put(
        vm.$store.state.filooServer + "exames/toggle/" + vm.toggleActiveId, {}, {
          headers: {
          Authorization: vm.$session.get("bearerDefault")
          },
        }
      )
      .then(function (response) {
        if (response.status == 200) {
          vm.$bvModal.hide("modal-change-status-exam");
          vm.showNotifySuccess("Operação realizada","O status do exame foi alterado com sucesso", 3000);
          vm.getExames();
        }
      }).catch(function () {
        vm.$bvModal.hide("modal-change-status-exam");
        vm.showNotifyError("Não foi possível alterar o status do exame", 6000);
      })
      .finally(function() {
        vm.$bvModal.hide("modal-change-status-exam");
      });
    },

    addNewExamePopup() {
      const vm = this;
      vm.invalidFields.name = false;
      vm.invalidFields.codExame = false;
      vm.popupExame = true;
      vm.popupExameData = {
        active: true,
        codTuss: undefined,
        codExame: undefined,
        id: undefined,
        name: undefined,
      }
    },

    editExamesPopup(exames) {
      const vm = this;
      vm.invalidFields.name = false;
      vm.invalidFields.codExame = false;
      vm.popupExame = true;
      vm.popupExameData = {
        active: exames.active,
        codTuss: exames.codTuss,
        codExame: exames.codExame,
        id: exames.id,
        name: exames.name,
      }
    },

    addNewExame() {
      const vm = this;

      if (vm.validateFields()) {
        vm.axios
        .post(
          vm.$store.state.filooServer + "exames", vm.popupExameData, {
            headers: {
              Authorization: vm.$session.get("bearerDefault")
            },
          }
        )
        .then(function (response) {
          if (response.status == 200) {
            vm.popupExame = false;
            vm.$swal({
              title: "Exame salvo!",
              icon: "success",
            });
          }
        });
      }
      
    },

    editExame() {
      const vm = this;

      if (vm.validateFields()) {
        vm.axios
        .put(
          vm.$store.state.filooServer + "exames/" + vm.popupExameData.id, vm.popupExameData, {
            headers: {
              Authorization: vm.$session.get("bearerDefault")
            },
          }
        )
        .then(function (response) {
          if (response.status == 200) {
            vm.popupExame = false;
            vm.getExames();
            vm.$swal({
              title: "Exame salvo!",
              icon: "success",
            });
          }
        });
      }
    },

    changeSearchExames() {
      const vm = this;
      vm.currentx = 1;
      vm.$vs.loading();
      vm.getExames();
    },

    validateFields() {
      const vm = this;
      vm.invalidFields.name = vm.testNullUndefinedEmpty(vm.popupExameData.name);
      vm.invalidFields.codExame = vm.testNullUndefinedEmpty(vm.popupExameData.codExame);

      return !vm.invalidFields.name && !vm.invalidFields.codExame
    },

    handleResize() {
      const vm = this;
      vm.windowWidth = window.innerWidth;
    },
  },
};
</script>

<style lang="scss" src="./RegisterExames.scss">
</style>